import { PremiumUI } from "./PremiumUI";

function Premium({ showPremium, setShowPremium }) {
  return (
    <PremiumUI
      variant="modal"
      show={showPremium}
      onClose={() => setShowPremium(false)}
    />
  );
}
export default Premium;